import { create } from "zustand";

type TState = {
  file: File | undefined;
  id?: string;
  users: {
    id: string;
    roleId: string;
  }[];
  region: string;
  country: string;
  name: string;
  displayName: string;
  industry: string;
  regionDomain: string;
};

type TAction = {
  setState: (state: keyof TState, payload: TState[keyof TState]) => void;
  setAllState: (payload: TState) => void;
  reset: () => void;
};

const initialState: TState = {
  name: "",
  file: undefined,
  country: "",
  displayName: "",
  industry: "",
  region: "",
  regionDomain: "us",
  users: [],
};

export const useStoreOrg = create<TState & TAction>((set) => ({
  setAllState: (payload) => set(payload),
  reset: () => set(initialState),
  ...initialState,
  setState: (stated, payload) =>
    set((state) => ({ ...state, [stated]: payload })),
}));
